export default __webpack_public_path__ + "static/media/salad1.e2aba134.jpeg";